import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"
import axios from "axios"

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

// Get options for goods order form
export const getGoodsOrderOptions = async (token) => {
    log("welcome in getGoodsOrderOptions")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/get_goods_order_options_api', {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in getGoodsOrderOptions", err)
        return { error: true, message: "Error fetching order options" }
    }
}

// Create a goods order
export const createGoodsOrder = async (token, orderData) => {
    log("welcome in createGoodsOrder")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/create_goods_order_api', orderData, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in createGoodsOrder", err)
        return { error: true, message: "Error creating order" }
    }
}

// Get goods orders for distributor to fulfill
export const getGoodsOrdersForDistributor = async (token) => {
    log("welcome in getGoodsOrdersForDistributor")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/get_goods_orders_for_distributor_api', {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in getGoodsOrdersForDistributor", err)
        return { error: true, message: "Error fetching orders" }
    }
}

// Validate serials before fulfillment
export const validateGoodsSerials = async (token, orderId, serials) => {
    log("welcome in validateGoodsSerials")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/validate_goods_serials_api', {
            order_id: orderId,
            serials: serials
        }, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in validateGoodsSerials", err)
        return { error: true, message: "Error validating serials" }
    }
}

// Fulfill goods order
export const fulfillGoodsOrder = async (token, orderId, serials, fulfillmentNotes = '') => {
    log("welcome in fulfillGoodsOrder")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/fulfill_goods_order_api', {
            order_id: orderId,
            serials: serials,
            fulfillment_notes: fulfillmentNotes
        }, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in fulfillGoodsOrder", err)
        return { error: true, message: "Error fulfilling order" }
    }
}

// Update goods order status
export const updateGoodsOrderStatus = async (token, orderId, status, notes = '') => {
    log("welcome in updateGoodsOrderStatus")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.put(BASE_URL + '/home/update_goods_order_status_api', {
            order_id: orderId,
            status: status,
            fulfillment_notes: notes
        }, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in updateGoodsOrderStatus", err)
        return { error: true, message: "Error updating order status" }
    }
}

// ==========================================
// ORDER RETURN/REVERSAL FUNCTIONS
// ==========================================

// Initiate order return
export const initiateOrderReturn = async (token, orderId, returnType, reason = '') => {
    log("welcome in initiateOrderReturn")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/initiate_order_return_api', {
            order_id: orderId,
            return_type: returnType,
            reason: reason
        }, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in initiateOrderReturn", err)
        return { error: true, message: "Error initiating return" }
    }
}

// Confirm physical return receipt
export const confirmOrderReturn = async (token, orderId, receivedSerials) => {
    log("welcome in confirmOrderReturn")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/confirm_order_return_api', {
            order_id: orderId,
            received_serials: receivedSerials
        }, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in confirmOrderReturn", err)
        return { error: true, message: "Error confirming return" }
    }
}

// Confirm lost order
export const confirmLostOrder = async (token, orderId, carrierConfirmation = '') => {
    log("welcome in confirmLostOrder")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/confirm_lost_order_api', {
            order_id: orderId,
            carrier_confirmation: carrierConfirmation
        }, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in confirmLostOrder", err)
        return { error: true, message: "Error confirming lost order" }
    }
}

// Process refund
export const processOrderRefund = async (token, orderId, refundMethod) => {
    log("welcome in processOrderRefund")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/process_order_refund_api', {
            order_id: orderId,
            refund_method: refundMethod
        }, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in processOrderRefund", err)
        return { error: true, message: "Error processing refund" }
    }
}
